import { Filter } from 'app/components/filters/types';
import { FavouriteCondition } from 'app/types-shared';
import { configuration } from 'app/components/filters/filters-panel/filter-types/configuration';
import { EditingValues } from 'app/components/filters/filters-panel/types';
import { searchInAllFieldsDomain } from 'app/area/favourite/constants';

export interface FilterMappingType {
  [key: string]: (filter: Filter) => FavouriteCondition[];
}

export const updateFilterConditions = (
  currentList: Filter[],
  editingValues: EditingValues,
  templateConditions: FavouriteCondition[]
): FavouriteCondition[] => {

  const filterMapping: FilterMappingType = configuration
    .map(item => item.mapper)
    .filter(item => item && item)
    .reduce((result, mapper: any) => ({
      ...result,
      ...mapper(editingValues)
    }), {});

  const orderedFilters = currentList
    .map(filter => filterMapping[filter.advancedSearchType] && filterMapping[filter.advancedSearchType](filter))
    .reduce((memo, f) => f ? [...memo, ...f] : memo, [])
    .filter(f => f && f.values && f.values.length > 0);

  return [
    ...templateConditions.filter(c => !currentList.some(f => f.domain === c.domain.v) || c.domain.v === searchInAllFieldsDomain),
    ...orderedFilters
  ].map((item, index) => { return { ...item, id: index + 1 } });
};
